import React from "react";
import "./Contact.css";
function Contact() {
  return (
    <div className="contact" id="contact">
      <h2>
        <span>Reach out..</span>
      </h2>
      <div className="contact__main">
        <img className="contact__wavebk" src="./wavebk.png" />
        <img className="contact__group" src="./group.png" />

        <div className="contact__first">
          <div className="projects__brand contact__tagline">
            <img src="./stars2.png" />
            <h2>Get In Touch With Us</h2>
            <p>
              We'll try to reply as soon as possible Thanks for your patience*
            </p>
          </div>
          <h3>Name : Yuvraj Agarkar</h3>
          <h3>Designation : CS and Engineering</h3>
          <h3>Professional Email : yuvraj.agarkar24@gmail.com</h3>
          <h3>Work Status : Open for work ,projects ,Startups etc.</h3>
        </div>
      </div>
    </div>
  );
}

export default Contact;
